var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import isEmpty from 'lodash.isempty';
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ContentContainer } from '../../../components/templates/ContentContainer';
import { ContentContextProvider } from '../../../contexts/content';
import { FactoryComponent } from '../../../factory';
import useDesign from '../../../hooks/useDesign';
import useScrollToTop from '../../../hooks/useScrollToTop';
function changePageDetailsAttribute(_a) {
    var id = _a.id, attrName = _a.attrName, value = _a.value;
    var el = document.getElementById(id);
    if (el)
        el[attrName] = value;
}
export var renderIndexIfHas = function (_a) {
    var index = _a.index, basePath = _a.basePath;
    return !!index && (_jsx(Route, { path: basePath, element: _jsx(Navigate, { to: index, replace: true }) }, "".concat(basePath).concat(index)));
};
export var renderRoutes = function (_a) {
    var routes = _a.routes, index = _a.index, basePath = _a.basePath;
    return routes
        .map(function (_a) {
        var path = _a.path, component = _a.component, design = _a.design, routeProps = _a.props;
        var config = useDesign(design).config;
        useScrollToTop({ path: path, scrollTop: config.scrollTop });
        return (_jsx(Route, __assign({ path: path, element: _jsx(ContentContextProvider, __assign({ path: path }, { children: _jsx(ContentContainer, { design: design, component: component }) })) }, routeProps, { children: !isEmpty(config.routes) &&
                renderRoutes({ routes: config.routes, index: config.index, basePath: config.basePath }) }), design));
    })
        .concat(renderIndexIfHas({ index: index, basePath: basePath }));
};
export var LayoutWithRoutes = function (_a) {
    var design = _a.design;
    var config = useDesign(design).config;
    var _b = config, routes = _b.routes, basePath = _b.basePath, index = _b.index, title = _b.title, description = _b.description, favicon = _b.favicon;
    useEffect(function () {
        if (title) {
            changePageDetailsAttribute({
                id: 'title',
                attrName: 'textContent',
                value: title,
            });
        }
        if (description) {
            changePageDetailsAttribute({
                id: 'description',
                attrName: 'textContent',
                value: description,
            });
        }
        if (favicon) {
            changePageDetailsAttribute({
                id: 'favicon',
                attrName: 'href',
                value: favicon,
            });
        }
    }, []);
    return (_jsxs(Routes, { children: [config === null || config === void 0 ? void 0 : config.content.map(function (_a) {
                var component = _a[0], compDesign = _a[1];
                return (_jsx(Route, __assign({ path: basePath, element: _jsx(FactoryComponent, { "data-design": compDesign, path: basePath, design: compDesign, component: component }) }, { children: renderRoutes({ routes: routes, basePath: basePath, index: index }) }), compDesign));
            }), index && _jsx(Route, { path: "*", element: _jsx(Navigate, { to: index, replace: true }) })] }));
};
LayoutWithRoutes.displayName = 'LayoutWithRoutes';
